import Toastify from 'toastify-js';
import { copyToClipboard } from '../utils/copyToClipboard';

function initialize() {
    $('.units .copy-btn').on('click', function () {
        copyToClipboard($(this).find('.copy-text').text());

        Toastify({
            text: $(this).data('copy-message'),
            duration: 1500,
            newWindow: true,
            close: true,
            gravity: 'top',
            position: 'center',
            stopOnFocus: true,
            style: {
                background: 'linear-gradient(135deg, #FF9441, #F36F21)',
            },
            onClick: function () {},
        }).showToast();
    });

    $('.units .btn-unit').on('click', function () {
        selectUnit($(this).data('id'));
    });
}

function selectUnit(id) {
    $('.units .btn-unit').removeClass('border-b-primary text-primary border-b-transparent text-dark bg-[#F0F0F0]');
    $(".units .btn-unit[data-id='" + id + "']").addClass('border-b-primary text-primary bg-[#F0F0F0]');
    $('.units .btn-unit')
        .not("[data-id='" + id + "']")
        .addClass('border-b-transparent text-dark');

    //Container
    $('.units .container-unit').addClass('hidden').removeClass('flex');
    $(".units .container-unit[data-id='" + id + "']")
        .removeClass('hidden')
        .addClass('flex');
}

initialize();
